import coverImg from "assets/images/v155/bg.webp"

export const v155Config = {
  cover: { en: coverImg },
}
